var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 text-center"},[_vm._v(_vm._s(new Date().getFullYear())+" © Groupe EMC")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }